import { useState } from "react";
import { SiteShell, useSiteData } from "@/components/site/SiteShell";
import { ClientsPopup } from "@/components/site/Popups";
import { bestSrc, srcSet } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function Home() {
  const site = useSiteData();
  const [info, setInfo] = useState(false);
  const images = Array.isArray(site?.home) ? site.home : [];

  useSeo({
    title: "Joe Tanis Photography — Architectural, Advertising & Still Life, NYC",
    description:
      "Joe Tanis Photography — NYC architectural, advertising and still life photographer specializing in jewelry, commercial and residential interiors, and product campaigns.",
    path: "/",
  });

  return (
    <SiteShell variant="home" infoOpen={info} onInfo={() => setInfo((v) => !v)}>
      <div className="sr-only" data-testid="home-seo-text">
        <h1>Joe Tanis Photography — Architectural, Advertising &amp; Still Life Photography in New York</h1>
        <p>
          Joe Tanis is a New York City photographer specializing in jewelry photography, architectural and interior
          photography, and advertising photography for brands, retailers, architects, designers and agencies.
        </p>
        <h2>Jewelry and product photography</h2>
        <p>
          Fine jewelry, diamond and gemstone photography, jewelry ecommerce images and styled editorial jewelry for clients
          including Christie&apos;s New York, MoMA Design Store, Barney&apos;s New York, David Yurman, Style Me Pretty and
          Grown Brilliance. Still life work also covers fragrance, eyewear, accessories, home goods and tabletop.
        </p>
        <h2>Architecture and interiors</h2>
        <p>
          Commercial interior photography for retail, office and hospitality spaces, and residential interior photography
          for architects, interior designers and real estate professionals, including work for Weppner Architects,
          Andersen Windows &amp; Doors, Dwell and Interior Design Magazine.
        </p>
        <h2>Advertising campaigns</h2>
        <p>
          Product advertising and campaign photography produced with art directors, stylists and models, including
          campaigns for Matter Surfaces and Dark Matter Audio Labs, holiday gift guides and eyewear for Allen Atelier.
          Contact: joe@joetanis.com.
        </p>
      </div>
      <div className="jt-strips" data-testid="home-strips">
        {images.map((img, i) => (
          <div className="jt-strip" key={img.media_id + i} data-testid={`home-strip-${i}`}>
            <img
              src={bestSrc(img, 1600)}
              srcSet={srcSet(img)}
              sizes="(max-width: 480px) 100vw, 60vw"
              alt={img.alt || ""}
              loading="eager"
              fetchpriority={i < 3 ? "high" : "auto"}
              decoding="async"
            />
          </div>
        ))}
        <div className="jt-strips-extra" />
      </div>
      {info && <ClientsPopup onClose={() => setInfo(false)} />}
    </SiteShell>
  );
}
